import React from "react";

const LoadingScreen = ({ message = "Yükleniyor..." }) => (
  <div style={{
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f0f0f0',
    fontFamily: 'sans-serif',
    color: '#333'
  }}>
    <div className="loader" style={{
      width: 40,
      height: 40,
      border: '5px solid #ccc',
      borderTop: '5px solid #3498db',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: 20
    }} />
    <p>{message}</p>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);
  
export default LoadingScreen;
